import { render, staticRenderFns } from "./PromotionIdDescription.vue?vue&type=template&id=5bb588bc&scoped=true"
import script from "./PromotionIdDescription.vue?vue&type=script&lang=js"
export * from "./PromotionIdDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb588bc",
  null
  
)

export default component.exports